// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { InteractiveIndicatorBaseService } from './interactive-indicator-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class InteractiveIndicatorMockService extends InteractiveIndicatorBaseService {
}
